import React, { useContext } from "react";
import google from "../../../../../images/LandingPageImage/google.png";
import Ornament from "../../../../../images/LandingPageImage/Ornament.svg";
import Navbar from "../../common/Navbar";
import FAQContactSection from "../FAQContactSection";
import CallToAction from "../CallToAction";
import template from "../../../../../images/LandingPageImage/template.png";
import Footer from "../../common/Footer";
import { Link } from "react-router-dom";
import MyContext from "../../../../../MyContext";

export default function PersonalizedMessaging() {
  const { openFreeTrialModal } = useContext(MyContext);

  return (
    <div>
      <div
        className="hero-bg pt-4 pt-md-5 overflow-hidden font-inter"
        style={{ minHeight: "90vh" }}
      >
        <Navbar />

        <div className="container mt-4 mt-lg-5 mb-5">
          <div className="row align-items-center justify-content-center">
            <div className="col-12 col-lg-6 px-3 px-md-4 order-2 order-lg-1 text-center text-lg-start mt-4 mt-lg-0">
              <h1 className="display-6 display-md-5 fw-semibold font-bricolage mb-3 mb-md-4 lh-sm text-white">
                Personalized Messaging: Build Stronger{" "}
                <br className="d-none d-md-block" />
                Customer Connections on <br className="d-none d-md-block" />
                <span style={{ color: "yellowgreen" }}>WhatsApp</span>
              </h1>

              <p
                className="small text-light opacity-90 mb-4 fw-light mx-auto mx-lg-0"
                style={{ maxWidth: "550px", lineHeight: "1.7" }}
              >
                In today’s crowded digital space, customers expect more than
                generic promotions. They respond better to messages that feel
                timely, relevant, and personal. Personalized WhatsApp messaging
                allows businesses to communicate in a way that feels natural,
                helpful, and human—turning everyday conversations into long-term
                relationships.
              </p>

              <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-lg-start gap-3 mt-4">
                <Link to="/login" className="text-decoration-none">
                  <button
                    type="button"
                    className="btn btn-outline-google rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 px-4 py-2"
                    style={{ minHeight: "48px" }}
                  >
                    <span
                      className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                      style={{ width: "28px", height: "28px" }}
                    >
                      <img
                        src={google}
                        alt="Google"
                        style={{ width: "16px" }}
                      />
                    </span>
                    <span className="text-nowrap">Start With Google</span>
                  </button>
                </Link>

                <button
                  onClick={openFreeTrialModal}
                  className="btn btn-outline-demo rounded-pill px-4 py-2 fw-semibold d-flex align-items-center justify-content-center"
                  style={{ minHeight: "48px" }}
                >
                  Book a Demo
                </button>
              </div>
            </div>

            <div className="col-12 col-lg-6 mb-5 mb-lg-0 order-2 order-lg-2">
              <div className="position-relative d-flex align-items-center justify-content-center p-2 p-md-3">
                <img
                  src={Ornament}
                  className="img-fluid floating-animation"
                  alt="Background"
                  style={{ opacity: "0.4", filter: "blur(15px)", width: "85%" }}
                />

                <img
                  src={template}
                  alt="personalized_messaging"
                  className="position-absolute img-fluid main-image-hover"
                  style={{
                    maxWidth: "85%",
                    height: "auto",
                    zIndex: 2,
                    filter: "drop-shadow(0px 15px 30px rgba(0,0,0,0.4))",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

      <style>{`
  @media (max-width: 767px) {
    .display-6 {
      font-size: 1.8rem !important;
    }
  }

  .main-image-hover {
    transition: all 0.5s ease-in-out;
  }

  .main-image-hover:hover {
    transform: scale(1.03) translateY(-10px);
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-20px);
    }
  }

  .floating-animation {
    animation: float 6s ease-in-out infinite;
  }
`}</style>

      </div>
      <section className="min-vh-100 d-flex who-bg align-items-center font-inter py-5 px-3">
        <div
          className="container mx-auto text-center"
          style={{ maxWidth: "1050px" }}
        >
          <h2 className="fs-2 fw-semibold font-bricolage text-white mb-4">
            What Is Personalized Messaging on WhatsApp?
          </h2>

          <div className="mb-5 px-md-5 mx-auto" style={{ maxWidth: "900px" }}>
            <p className="fs-6 opacity-90 mb-4 fw-light lh-lg text-yellowgreen">
              Personalized messaging means tailoring WhatsApp communication
              based on customer data such as name, preferences, purchase
              history, location, or stage in the customer journey.
            </p>
          </div>

          <div className="row g-2 g-lg-3 justify-content-center mt-2">
            <div className="col-12 col-md-6 col-lg-6">
              <div
                className="glass-card h-100 p-3 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h5 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Why Personalized Messages Matter for Businesses
                </h3>
                <p className="text-white opacity-75 fw-light lh-base">
                  Generic messages are easy to ignore, while personalized
                  communication encourages action. When customers receive
                  messages aligned with their needs and interests, they are more
                  likely to open, read, and respond.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-6">
              <div
                className="glass-card h-100 p-3 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h5 fw-bold mb-3 text-yellowgreen font-bricolage">
                  SendBulkMsg Delivers Personalization at Scale
                </h3>
                <p className="text-white opacity-75 fw-light lh-base">
                  SendBulkMsg is designed to help businesses personalize
                  WhatsApp communication effortlessly, whether they are
                  messaging hundreds or thousands of users. The platform enables
                  brands to customize messages using customer details, segment
                  audiences based on behavior and engagement, send dynamic
                  offers and recommendations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="min-vh-100 d-flex who-bg align-items-center font-inter py-5 px-3">
        <div
          className="container mx-auto text-center"
          style={{ maxWidth: "1150px" }}
        >
          <h2 className="fs-2 fw-bold font-bricolage text-white mb-4">
            Personalized Messaging for Different Business Goals
          </h2>

          <div className="mb-5 px-md-5 mx-auto" style={{ maxWidth: "900px" }}>
            <p className="fs-6 opacity-90 mb-4 fw-light lh-lg text-yellowgreen">
              For sales and promotions, personalized messages allow businesses
              to share relevant offers and product recommendations based on past
              purchases, leading to higher conversions than mass messaging.
            </p>
          </div>

          <div className="row g-4 justify-content-center mt-2">
            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Smart Personalization Made Simple
                </h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  SendBulkMsg makes it easy to create customized WhatsApp
                  messages using customer data and automation, delivering
                  relevant and human conversations at scale.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Stronger Engagement, Better Results
                </h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Personalized WhatsApp messaging builds trust, improves
                  engagement, and increases conversions, helping businesses turn
                  chats into lasting relationships.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Automation Without Human Loss
                </h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  SendBulkMsg combines smart automation with personalization,
                  ensuring every message feels natural and conversational while
                  saving time and effort.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Data-Driven Conversations
                </h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Use customer behavior, preferences, and interaction history to
                  send timely, relevant messages that resonate and drive
                  meaningful responses.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Scalable Messaging
                </h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Whether you message hundreds or thousands of users,
                  SendBulkMsg helps you scale personalized communication
                  smoothly without compromising quality.
                </p>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div
                className="glass-card h-100 p-4 p-md-4 rounded-4 text-start border border-light border-opacity-10 shadow-lg transition-all hover-effect"
                style={{
                  background:
                    "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
                }}
              >
                <h3 className="h6 fw-bold mb-3 text-yellowgreen font-bricolage">
                  Convert Chats into Customers
                </h3>
                <p className="text-white opacity-75 fw-light small lh-base">
                  Targeted WhatsApp messages help move users from interest to
                  action, improving conversions and building long-term brand
                  loyalty.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FAQContactSection />
      <CallToAction />
      <Footer />
    </div>
  );
}
